import Footer from "../../component/Footer"; 
import AgentNavbar from "../../component/AgentNavbar";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import BookWithUs from "../../component/BookWithUs";
import TopPlaces from "../../component/TopPlaces";
import { Plus, ChevronDown, Trash2 } from "react-feather";
import { baseurl } from "../../component/Baseurl";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Navbar from "../../component/Navbar";

function VisitorHotelSearch() {
  const [rooms, setRooms] = useState([
    { adults: 2, children: 0 }, // Default Room
  ]); // Room state (each room has adults and children)

  const [departureDate, setDepartureDate] = useState(""); // Departure date
  const [returnDate, setReturnDate] = useState(""); // Return date
  const navigate = useNavigate();
  // Handle passenger count changes for a specific room
  const handleCountChange = (roomIndex, type, operation) => {
    const updatedRooms = [...rooms];
    const room = updatedRooms[roomIndex];

    if (type === "adults") {
      if (operation === "increase" && room.adults < 2) {
        room.adults += 1;
      } else if (operation === "decrease" && room.adults > 1) {
        room.adults -= 1;
      }
    } else if (type === "children") {
      if (operation === "increase" && room.children < 2) {
        room.children += 1;
      } else if (operation === "decrease" && room.children > 0) {
        room.children -= 1;
      }
    }

    setRooms(updatedRooms);
  };

 
  const [cities, setCities] = useState([]); // Store fetched cities
  const [selectedCity, setSelectedCity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);

   
  // Function to fetch cities based on user input
  const fetchCities = (inputValue) => {
    if (!inputValue) {
      setCities([]); // Clear list if no input
      return;
    }

    setLoading(true);

    fetch(`${baseurl}getAllCities?search=${inputValue}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.cities) {
          setCities(data.cities);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
        setLoading(false);
      });
  };



  // Handle input change for search functionality
  const handleInputChange = (inputValue) => {
    if (!inputValue) {
      setFilteredCities(cities); // Reset if input is empty
      return;
    }

    // Filter cities based on user input
    const filtered = cities.filter((city) =>
      city.city_name.toLowerCase().includes(inputValue.toLowerCase())
    );

    setFilteredCities(filtered);
  };

  // Remove a room
  const removeRoom = (roomIndex) => {
    const updatedRooms = rooms.filter((_, index) => index !== roomIndex);
    setRooms(updatedRooms);
  };

   // Add new room
   const addRoom = () => {
    if (rooms.length < 5) {
      setRooms([...rooms, { adults: 1, children: 0 }]);
    }
  };

  // Handle form submission
 const handleSubmit = (e) => {
  e.preventDefault();

  // Get form data
  const departureDateObj = new Date(departureDate);
const returnDateObj = new Date(returnDate);

const dayDifference = Math.ceil((returnDateObj - departureDateObj) / (1000 * 60 * 60 * 24)); // Convert ms to days

const formData = {
    from: e.target.from.value,
    departure: departureDate,
    return: returnDate,
    day: dayDifference,  // Number of days between departure and return
    rooms: JSON.stringify(rooms),  
};


  console.log("formData", formData);

  // Convert formData to query parameters
  const queryParams = new URLSearchParams(formData).toString();

  // Navigate to hotel-result with query parameters
  navigate(`/search-hotel-result?${queryParams}`);
};


useEffect(() => {
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  $("#departure-datepicker").datepicker({
    dateFormat: "dd M y",
    minDate: today,
    defaultDate: today,
    onSelect: function (dateText, inst) {
      const selectedDate = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
      setDepartureDate(
        `${inst.selectedYear}-${(inst.selectedMonth + 1).toString().padStart(2, "0")}-${inst.selectedDay
          .toString()
          .padStart(2, "0")}`
      );

      // Set return date to one day after departure date
      const nextDay = new Date(selectedDate);
      nextDay.setDate(selectedDate.getDate() + 1);

      setReturnDate(
        `${nextDay.getFullYear()}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay
          .getDate()
          .toString()
          .padStart(2, "0")}`
      );

      // Update minDate for return-datepicker
      $("#return-datepicker").datepicker("option", "minDate", nextDay);

      // Only auto-set return date if the selected return date is earlier than nextDay
      const currentReturnDate = $("#return-datepicker").datepicker("getDate");
      if (currentReturnDate < nextDay) {
        $("#return-datepicker").datepicker("setDate", nextDay);
      }
    },
  });

  $("#return-datepicker").datepicker({
    dateFormat: "dd M y",
    minDate: tomorrow,
    defaultDate: tomorrow,
    onSelect: function (dateText, inst) {
      setReturnDate(
        `${inst.selectedYear}-${(inst.selectedMonth + 1).toString().padStart(2, "0")}-${inst.selectedDay
          .toString()
          .padStart(2, "0")}`
      );
    },
  });

  // Set initial dates
  $("#departure-datepicker").datepicker("setDate", today);
  $("#return-datepicker").datepicker("setDate", tomorrow);
}, []);
  

  return (
    <>
      <Navbar/>
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <h1 className="text-start  agenth1  font3 txt6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40px"
              viewBox="0 -960 960 960"
              width="40px"
              fill="#000000"
            >
              <path d="M40-200v-590h66.67v396h342v-312.67H770q61.88 0 105.94 44.07Q920-618.54 920-556.67V-200h-66.67v-127.33H106.67V-200H40Zm233.33-246q-46.66 0-78.66-32t-32-78.67q0-46.66 32-78.66t78.66-32q46.67 0 78.67 32t32 78.66Q384-510 352-478t-78.67 32Zm242 52h338v-162.67q0-34.37-24.48-58.85Q804.38-640 770-640H515.33v246Zm-242-118.67q18.34 0 31.17-12.83 12.83-12.83 12.83-31.17 0-18.33-12.83-31.16-12.83-12.84-31.17-12.84-18.33 0-31.16 12.84-12.84 12.83-12.84 31.16 0 18.34 12.84 31.17 12.83 12.83 31.16 12.83Zm0-44Zm242-83.33v246-246Z" />
            </svg>
            Search Hotel
          </h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">
                  Going to
                </label>
                {/* <input
                  type="text"
                  className="input2"
                  name="from"
                  placeholder="Delhi"
                  required
                /> */}
               <Select
      options={cities.map((city) => ({
        value: city.city_code,
        label: `${city.city_name} (${city.country_name})`,
      }))}
      name="from"
      className=" "
      placeholder="Search City"
      value={selectedCity}
      onChange={setSelectedCity}
      onInputChange={fetchCities} // Fetch cities dynamically
      isSearchable
      isLoading={loading}  
    />

              </div>

              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">
                  Check-in
                </label>
                <input
                  type="text"
                  id="departure-datepicker"
                  className="input2"
                  name="departure"
                  placeholder="Select date"
                  required
                />
              </div>

              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">
                  Check-out
                </label>
                <input
                  type="text"
                  id="return-datepicker"
                  className="input2"
                  name="return"
                  placeholder="Select date"
                  required
                />
              </div>
            </div>

            {rooms.map((room, index) => (
              <div className="row g-2 text-start mb-4" key={index}>
                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">Room</label>
                  <div>
                    <div className=" k1">Room {index + 1}</div>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">
                    Adults (12+)
                  </label>
                  <div className="d-flex justify-content-between align-items-center bg-white p-1 rounded border">
                    <span
                      className="btn3"
                      onClick={() =>
                        handleCountChange(index, "adults", "decrease")
                      }
                    >
                      -
                    </span>
                    <span>{room.adults}</span>
                    <span
                      className="btn3"
                      onClick={() =>
                        handleCountChange(index, "adults", "increase")
                      }
                    >
                      +
                    </span>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">
                    Children (2-11)
                  </label>
                  <div className="d-flex justify-content-between align-items-center bg-white p-1 rounded border">
                    <span
                      className="btn3"
                      onClick={() =>
                        handleCountChange(index, "children", "decrease")
                      }
                    >
                      -
                    </span>
                    <span>{room.children}</span>
                    <span
                      className="btn3"
                      onClick={() =>
                        handleCountChange(index, "children", "increase")
                      }
                    >
                      +
                    </span>
                  </div>
                </div>

                {index > 0 && (
                  <div className="col-md-2">
                    <label className="text-dark mb-2 labelset1 font3">
                      Remove Room
                    </label>
                    <div>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeRoom(index)}
                      >
                        <Trash2 size={17} />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}

            <div className="row g-2">
              <div className="col-md-12 text-end">
                <button type="button" className="btn4 btn-sm" onClick={addRoom}>
                  <Plus size={17} /> Add Room
                </button>
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Search
              </button>
            </div>
          </form>

          <hr className="mt-4" />

          <p>
            The Search Hotel page helps users find and book accommodations
            easily. Enter your destination (Going to), select Check-in and
            Check-out dates, and specify room preferences. The intuitive
            interface ensures a smooth and efficient hotel booking process
            tailored to your needs.
          </p>
        </div>
      </div>

      <TopPlaces />
      <BookWithUs />
      <Footer />
    </>
  );
}

export default VisitorHotelSearch;
